import acpVirtualCardsFaqTemplate from './templates/acp-virtual-cards-faq.html';
import acpVirtualCardsHowToUseTemplate from './templates/acp-virtual-cards-howtouse.html';
// @ngInject

function AcpVirtualCardsBottomLinksComponentCtrl(
  acpVirtualCardsModel,
  nsPermissions
) {
  var vm = this;
  vm.maxActiveVirtualCards = acpVirtualCardsModel.getMaxActiveVirtualCards();
  vm.currentVirtualCardsActivatedThisYear = acpVirtualCardsModel.getCurrentVirtualCardsActivatedThisYear();
  vm.maxVirtualCardsActivatedThisYear = acpVirtualCardsModel.getMaxVirtualCardsActivatedThisYear();

  function init() {
    nsPermissions
      .requestPermissions(['isFeatureGatingForVirtualCard'])
      .then(function (permissions) {
        vm.permissions = permissions;
      });
  }

  init();
}

var acpVirtualCardsBottomLinksComponent = {
  controller: AcpVirtualCardsBottomLinksComponentCtrl,
  controllerAs: 'vm',
  template: [
    '$attrs',
    function ($attrs) {
      if ($attrs.mode === 'faq') {
        return acpVirtualCardsFaqTemplate;
      } else {
        return acpVirtualCardsHowToUseTemplate;
      }
    }
  ],
  bindings: {
    maxActiveVirtualCards: '<',
    currentVirtualCardsActivatedThisYear: '<',
    maxVirtualCardsActivatedThisYear: '<'
  }, // bindings advice: https://docs.angularjs.org/guide/component#component-based-application-architecture
  require: {}
};

export default acpVirtualCardsBottomLinksComponent;
